import {
    FETCH_VACATIONS_REQUEST,
    FETCH_VACATIONS_SUCCESS,
    FETCH_VACATIONS_FAILURE,
    
    FETCH_VACATIONS_POOL_REQUEST,
    FETCH_VACATIONS_POOL_SUCCESS,
    FETCH_VACATIONS_POOL_FAIL,

    CREATE_VACATION_REQUEST,
    CREATE_VACATION_SUCCESS,
    CREATE_VACATION_FAIL,
    CREATE_VACATION_RESET,

    DELETE_VACATION_REQUEST,
    DELETE_VACATION_SUCCESS,
    DELETE_VACATION_FAIL,
    DELETE_VACATION_RESET,

    UPDATE_VACATION_REQUEST,
    UPDATE_VACATION_SUCCESS,
    UPDATE_VACATION_FAIL,
    UPDATE_VACATION_RESET
} from '../constants/vacationConstants';

const initialState = {
    vacations: [],
    loading: false,
    error: null
};

export const vacationListReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_VACATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_VACATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                vacations: action.payload.results,
                pages: Math.ceil(action.payload.count / 10), // <<< PAGE_SIZE
                page: action.payload.current
            };
        case FETCH_VACATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export const vacationCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_VACATION_REQUEST:
        return { loading: true };
    case CREATE_VACATION_SUCCESS:
        return { loading: false, success: true };
    case CREATE_VACATION_FAIL:
        return { loading: false, error: action.payload };
    case CREATE_VACATION_RESET:
        return {};
    default:
        return state;
  }
};

export const vacationDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_VACATION_REQUEST:
      return { loading: true };
    case DELETE_VACATION_SUCCESS:
      return { loading: false, success: true };
    case DELETE_VACATION_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_VACATION_RESET:
      return {};
    default:
      return state;
  }
};

export const vacationUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_VACATION_REQUEST:
      return { loading: true };
    case UPDATE_VACATION_SUCCESS:
      return { loading: false, success: true };
    case UPDATE_VACATION_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_VACATION_RESET:
      return {};
    default:
      return state;
  }
};

export const vacationPoolReducer = (state = { loading: false, pool: {} }, action) => {
  switch (action.type) {
    case FETCH_VACATIONS_POOL_REQUEST:
      return { ...state, loading: true };
    case FETCH_VACATIONS_POOL_SUCCESS:
      return { loading: false, pool: action.payload };
    case FETCH_VACATIONS_POOL_FAIL:
      return { loading: false, error: action.payload, pool: {} };
    default:
      return state;
  }
};